import React, { useState } from "react";
import Moment from "react-moment";
import { Modal } from "react-bootstrap";
import "./ViewTaskDetail.css";
import PreviewFile from "../../Common/Form/PreviewFile/PreviewFile";
import AttachmentGallery from "../../Common/Form/AttachmentGallery/AttachmentGallery";

const getFileNameFromUrl = (url = "") => {
  try {
    const decoded = decodeURIComponent(url.split("?")[0]);
    return decoded.substring(decoded.lastIndexOf("/") + 1) || "Attachment";
  } catch (e) {
    return "Attachment";
  }
};

// The list/detail APIs return multiple attachments as a single comma-separated
// string on task_file_name.
const parseAttachmentList = (value) => {
  if (!value) return [];
  return String(value)
    .split(",")
    .map((url) => url.trim())
    .filter(Boolean);
};

const TaskInfo = ({ taskData }) => {
  const [previewUrl, setPreviewUrl] = useState(null);

  if (!taskData) {
    return <div className="container mt-3">No task data available.</div>;
  }

  return (
    <div className="container">
      <div className="row align-items-start">
        <div className="col-md-12">
          <form className="mt-3 ps-3">
            <div className="row align-items-center">
              <div className="col-md-3">
                <label className="task_view_label">Task ID</label>
                <div className="task_view_text">{taskData.task_seq_id || "NA"}</div>
              </div>
              <div className="col-md-3">
                <label className="task_view_label">Task Name</label>
                <div className="task_view_text">{taskData.task_name || "NA"}</div>
              </div>
              <div className="col-md-3">
                <label className="task_view_label">Incident Category</label>
                <div className="task_view_text">{taskData.incident_type || "NA"}</div>
              </div>
              <div className="col-md-3">
                <label className="task_view_label">Task Type</label>
                <div className="task_view_text">{taskData.task_type || "NA"}</div>
              </div>
            </div>

            <div className="row align-items-center mt-3">
              <div className="col-md-4">
                <label className="task_view_label">Assigned To</label>
                <div className="task_view_text">{taskData.role_name || "NA"}</div>
              </div>
              <div className="col-md-4">
                <label className="task_view_label">Created On</label>
                <div className="task_view_text">
                  {taskData.created_on ? (
                    <Moment format="DD-MM-YYYY, hh:mm A">{taskData.created_on}</Moment>
                  ) : (
                    "NA"
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <label className="task_view_label">Status</label>
                <div className="task_view_text">{taskData.status ? "Active" : "Inactive"}</div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-12">
                <label className="task_view_label">Description</label>
                <div className="task_view_text">{taskData.description || "NA"}</div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-12">
                <label className="task_view_label">Attachment{parseAttachmentList(taskData.task_file_name).length > 1 ? "s" : ""}</label>
                <div className="task_view_text">
                  {parseAttachmentList(taskData.task_file_name).length > 0 ? (
                    <AttachmentGallery
                      urls={parseAttachmentList(taskData.task_file_name)}
                      onOpen={setPreviewUrl}
                      visibleCount={4}
                    />
                  ) : (
                    "NA"
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {previewUrl && (
        <PreviewFile
          file={{ name: getFileNameFromUrl(previewUrl), url: previewUrl }}
          show={!!previewUrl}
          previewHandler={() => setPreviewUrl(null)}
          title="Attachment Preview"
        />
      )}
    </div>
  );
};

export default TaskInfo;
